class FooterElement extends HTMLElement {
  constructor() {
    super();
    this.announcementKey = Theme.keys.announcement_key;
  }

  connectedCallback() {
    if (this.isAnnouncementClosed()) {
      return;
    }

    this.setAttribute("data-announcement-bar", "true");

    document.addEventListener("announcement-bar:closed", () => {
      this.setAttribute("data-announcement-bar", "false");
    });
  }

  disconnectedCallback() {
    document.removeEventListener("announcement-bar:closed", () => {
      this.setAttribute("data-announcement-bar", "false");
    });
  }

  isAnnouncementClosed() {
    return localStorage.getItem(this.announcementKey) !== null;
  }
}

customElements.define("footer-element", FooterElement);
